import { IAppContextAirport, useAppContext } from '../app-context'

const useAirport = () => {
  const { state } = useAppContext()

  return state.airport as IAppContextAirport
}

export default useAirport
